import { create } from 'zustand'

export const useStore = create((set, get) => ({
    films: [],
    setFilms: (films) => set({ films: films }),
    hasMore: false,
    setHasMore: (hasMore) => set({hasMore: hasMore}),
    genres: [],
    setGenres: (genres) => set({ genres: genres }),
    countries: [],
    setCountries: (countries) => set({ countries: countries }),
    languages: [],
    setLanguages: (languages) => set({ languages: languages }),

    error: null,
    setError: (error) => set({ error: error }),

    visibility: JSON.parse(localStorage.getItem('cinefilter_visibility') || '{"directors":true,"writers":false,"cinematographers":false,"actors":true,"composers":false,"prodDesigners":false,"genres":true,"studios":false,"countries":false,"language":false}'),
    toggleVisibility: (key) => set((state) => {
        const newVis = { ...state.visibility, [key]: !state.visibility[key] }
        localStorage.setItem('cinefilter_visibility', JSON.stringify(newVis))
        return { visibility: newVis }
    }),

    loading: false,
    setLoading: (value) => set({ loading: value }),
    changed: false,
    setChanged: (value) => set({ changed: value }),
    reload: false,
    causeReload: () => set((state) => ({ reload: state.reload + 1 })),
}))